module.exports = __webpack_public_path__ + "media/img/landing/hero_categories-305995fec4cef33d84f4f88fe8f638c4.jpg";